/*
 * Copyright (c) Dito Technologies
 */

import React from "react";
import {createFragmentContainer} from "react-relay";
import {graphql} from "babel-plugin-relay/macro";
import {PieceSettingsBody_piece$data} from "ui/feature/piece-settings/__generated__/PieceSettingsBody_piece.graphql";
import PieceSettingsDeleteItem from "ui/feature/piece-settings/PieceSettingsDeleteItem";
import PieceSettingsNameItem from "ui/feature/piece-settings/PieceSettingsNameItem";
import {PieceSettingsBody_viewer$data} from "ui/feature/piece-settings/__generated__/PieceSettingsBody_viewer.graphql";
import PieceSettingsBodyEmployeeOnlySection from "ui/feature/piece-settings/PieceSettingsBodyEmployeeOnlySection"
import PieceSettingsTempoItem from "ui/feature/piece-settings/PieceSettingsTempoItem";

interface Props {
    piece: PieceSettingsBody_piece$data
    viewer: PieceSettingsBody_viewer$data;
}

const PieceSettingsBody: React.FC<Props> = ({piece, viewer}) => {
    return (
        <div>
            <PieceSettingsNameItem piece={piece}/>
            <PieceSettingsTempoItem piece={piece}/>
            <PieceSettingsDeleteItem pieceId={piece.id}/>
            {viewer.me.is_employee && <PieceSettingsBodyEmployeeOnlySection piece={piece}/>}
        </div>
    );
}

export default createFragmentContainer(PieceSettingsBody, {
    viewer: graphql`
    fragment PieceSettingsBody_viewer on MusicViewer {
        me {
            is_employee
        }
    }
    `,
    piece: graphql`
    fragment PieceSettingsBody_piece on MusicPiece {
        id
        name
        ...PieceSettingsNameItem_Piece
        ...PieceSettingsBodyEmployeeOnlySection_piece
        ...PieceSettingsTempoItem_piece
    }
    `
});